// import logScope from 'log-scope'
// const log = logScope('store/admin')

const logDocumentRead = (state, type, value) => {
  if (!state.documentReads[type]) {
    state.documentReads[type] = 0
  }

  state.documentReads[type] += value
  state.totalDocumentReads += value
}

export default {
  state: {
    coupons: [],
    partners: [],
    subscribers: [],
    purchases: [],
    klarnaPurchases: [],
    manualPurchases: [],
    kpi: [],
    headQ: [],
    headQFirmware: [],
    latest: [],
    salesFunnel: [],
    newConnection: [],
    onboarding: [],
    setupLog: [],
    users: [],
    rides: [],
    documentReads: {},
    salesChannels: [{
      label: 'Web shop',
      value: 1
    }, {
      label: 'Event',
      value: 2
    }, {
      label: 'Fair',
      value: 3
    }, {
      label: 'Direct sales',
      value: 4
    }, {
      label: 'Partner (not via web shop)',
      value: 5
    }, {
      label: 'Other',
      value: 0
    }],
    totalDocumentReads: 0
  },
  mutations: {
    logDocumentRead: (state, { type, quantity }) => {
      logDocumentRead(state, type, quantity)
    },
    coupons: (state, value) => {
      state.coupons = value
      logDocumentRead(state, 'coupon', value.length)
    },
    partners: (state, value) => {
      state.partners = value
      logDocumentRead(state, 'partners', value.length)
    },
    subscribers: (state, value) => {
      state.subscribers = value
    },
    manualPurchases: (state, value) => {
      state.manualPurchases = value
      logDocumentRead(state, 'manualPurchases', value.length)
    },
    klarnaPurchases: (state, value) => {
      state.klarnaPurchases = value
      logDocumentRead(state, 'klarnaPurchases', value.length)
    },
    kpi: (state, value) => {
      state.kpi = value
      logDocumentRead(state, 'kpi', value.length)
    },
    purchases: (state, value) => {
      state.purchases = value
      logDocumentRead(state, 'purchases', value.length)
    },
    headQ: (state, value) => {
      state.headQ = value
      logDocumentRead(state, 'headQ', value.length)
    },
    headQFirmware: (state, value) => {
      state.headQFirmware = value
      logDocumentRead(state, 'headQFirmware', value.length)
    },
    latest: (state, value) => {
      state.latest = value
      logDocumentRead(state, 'latest', value.length)
    },
    salesFunnel: (state, value) => {
      state.salesFunnel = value
      logDocumentRead(state, 'salesFunnel', value.length)
    },
    newConnection: (state, value) => {
      state.newConnection = value
      logDocumentRead(state, 'newConnection', value.length)
    },
    onboarding: (state, value) => {
      state.onboarding = value
      logDocumentRead(state, 'onboarding', value.length)
    },
    users: (state, value) => {
      state.users = value
      logDocumentRead(state, 'users', value.length)
    },
    rides: (state, value) => {
      state.rides = value
      logDocumentRead(state, 'rides', value.length)
    },
    setupLog: (state, value) => {
      state.setupLog = value
      logDocumentRead(state, 'setupLog', value.length)
    }
  },
  getters: {
    newConnection: state => state.newConnection,
    salesChannels: state => state.salesChannels,
    onboarding: state => state.onboarding,
    setupLog: state => state.setupLog,
    users: state => state.users,
    rides: state => state.rides,
    salesChannel: state => {
      return (id) => {
        const salesChannel = state.salesChannels
          .find(s => s.value === id)

        return salesChannel ? salesChannel.label : '-'
      }
    },
    coupons: state => {
      return state.coupons.sort((a, b) => b.start - a.start)
    },
    partners: state => {
      return state.partners.sort((a, b) => b.start - a.start)
    },
    subscribers: state => {
      const emailMap = state.subscribers.map(sub => sub.email)

      return state.subscribers
        .filter((sub, index) => emailMap.indexOf(sub.email) === index)
        .sort((a, b) => a.timestamp - b.timestamp)
    },
    manualPurchases: state => {
      return state.manualPurchases.map(order => ({
        ...order,
        collection: 'manualPurchases'
      }))
    },
    kpi: state => {
      return state.kpi.sort((a, b) => b.week - a.week)
    },
    klarnaPurchases: state => {
      return state.klarnaPurchases.map(order => ({
        paymentMethod: 'klarna',
        collection: 'klarnaPurchases',
        id: order.id,
        address: order.shipping_address.street_address,
        city: order.shipping_address.city,
        couponCode: order.couponCode || '',
        email: order.shipping_address.email,
        firstName: order.shipping_address.given_name,
        lastName: order.shipping_address.family_name,
        phoneNumber: order.shipping_address.phone,
        postCode: order.shipping_address.postal_code,
        price: order.order_lines[0].total_amount / (order.order_lines[0].quantity * 100),
        total: order.order_lines[0].total_amount / 100,
        quantity: order.order_lines[0].quantity,
        status: typeof order.status === 'number' ? order.status : 0,
        timestamp: order.timestamp,
        note: order.note || '',
        salesChannel: 1, // web shop
        isSent: order.isSent === true
      }))
    },
    purchases: (state, getters) => {
      return [
        ...getters.manualPurchases,
        ...state.purchases.map(purchase => ({
          ...purchase,
          collection: 'purchases',
          salesChannel: 1 // web shop
        })),
        ...getters.klarnaPurchases
      ].sort((a, b) => b.timestamp - a.timestamp)
    },
    newPurchases: (_state, getters) => {
      let q = 0

      getters.purchases.forEach(({ status }) => {
        if (status === 0) {
          q++
        }
      })

      return q
    },
    headQ: state => {
      return state.headQ
    },
    headQFirmware: state => {
      return state.headQFirmware.sort((a, b) => b.version - a.version)
    },
    latest: state => {
      return state.latest.sort((a, b) => b.timestamp - a.timestamp)
    },
    salesFunnel: state => state.salesFunnel,
    documentReads: state => state.documentReads,
    totalDocumentReads: state => state.totalDocumentReads,
    purchasesAsCSV: (_state, getters) => {
      const purchases = getters.purchases
      const columns = ['firstName', 'email', 'phoneNumber', 'paymentMethod', 'address', 'postCode', 'city', 'couponCode', 'partnerCode', 'abTestCode', 'price', 'quantity', 'total', 'salesChannel', 'status', 'timestamp', 'note']

      return columns.join('\t') + '\n' +
        purchases.map(purchase => {
          let cols = columns.map(col => {
            let value = purchase[col]

            if (typeof value === 'string') {
              value = value.replace(/\n/g, ' ')
            }

            if (col === 'salesChannel') {
              return getters.salesChannel(value)
            } else if (col === 'timestamp') {
              return new Date(value).toLocaleDateString()
            } else if (col === 'status') {
              return {
                0: 'New',
                1: 'Sent',
                2: 'Billed',
                3: 'Returned',
                4: 'Other'
              }[value]
            } else if (col === 'firstName') {
              return `${purchase.firstName} ${purchase.lastName}`
            }

            return value
          })

          return cols.join('\t')
        }).join('\n')
    }
  },
  actions: {}
}
